class HeaderDrawerV2 extends HeaderDrawer {
    constructor() {
      super();
      this.headerWrapper = document.querySelector('.header-wrapper');
    }

    connectedCallback() {
      this.initAccordion();
    }

    openMenuDrawer(summaryElement) {
      super.openMenuDrawer(summaryElement);
      if (this.headerWrapper) {
        this.headerWrapper.classList.add('header--mega-menu-open');
        console.log(this.headerWrapper.classList)
      }
    }

    initAccordion() {
      const menus = this.querySelectorAll('.menu-drawer__menu');

      menus.forEach(menu => {
        const submenu = menu.querySelector('.menu-drawer__submenu');
        if (submenu) {
          menu.addEventListener('click', () => {
            const isExpanded = menu.classList.contains('menu-drawer__menu--expanded');

            if (isExpanded) {
              menu.classList.remove('menu-drawer__menu--expanded');
              submenu.style.maxHeight = null;
            } else {
              menu.classList.add('menu-drawer__menu--expanded');
              submenu.style.maxHeight = submenu.scrollHeight + 'px';
            }
          });
        }
      });
    }
}

customElements.define('header-drawer-v2', HeaderDrawerV2);